import { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getSavedTheme, saveThemeToLocalStorage } from '../utils/themeStorage';

export const useTheme = () => {
    const { isTelegramApp, telegramTheme } = useSelector((state) => state.telegram);
    const [darkMode, setDarkMode] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Отслеживаем изменение размера экрана
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        
        // Проверяем сразу
        checkScreenSize();
        
        // Добавляем слушатель
        window.addEventListener('resize', checkScreenSize);
        
        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    // Инициализация темы
    useEffect(() => {
        console.log('🔧 Theme initialization:', { isTelegramApp, telegramTheme });
        
        if (isTelegramApp && telegramTheme) {
            // Для Telegram WebApp используем тему из приложения
            const isDark = telegramTheme === 'dark';
            console.log('🔧 Using Telegram theme:', isDark);
            setDarkMode(isDark);
            document.documentElement.classList.toggle('dark', isDark);
        } else {
            // Для обычного сайта используем сохраненную настройку
            const savedTheme = getSavedTheme();
            console.log('🔧 Using saved theme:', savedTheme);
            setDarkMode(savedTheme);
            document.documentElement.classList.toggle('dark', savedTheme);
        }
    }, [isTelegramApp, telegramTheme]);

    // Восстанавливаем тему из localStorage при каждом рендере (если не Telegram)
    useEffect(() => {
        if (!isTelegramApp) {
            const savedTheme = getSavedTheme();
            console.log('🔧 Restoring theme from localStorage:', savedTheme);
            setDarkMode(savedTheme);
            document.documentElement.classList.toggle('dark', savedTheme);
        }
    });

    // Обработчик изменения темы
    const handleThemeChange = useCallback(() => {
        console.log('🔧 handleThemeChange called:', { isTelegramApp, isMobile });
        
        if (isTelegramApp && isMobile) {
            // В Telegram WebApp на мобильных устройствах тема не изменяется
            console.log('🔧 Theme change blocked: Telegram WebApp on mobile');
            return;
        }

        // Для обычного сайта или Telegram на широком экране переключаем тему
        console.log('🔧 Switching theme for browser version or Telegram on wide screen');
        setDarkMode(prevDarkMode => {
            const newDarkMode = !prevDarkMode;
            console.log('🔧 Theme switching from', prevDarkMode, 'to', newDarkMode);
            saveThemeToLocalStorage(newDarkMode);
            document.documentElement.classList.toggle('dark', newDarkMode);
            return newDarkMode;
        });
    }, [isTelegramApp, isMobile]);

    // Синхронизация с Telegram темой при изменении
    useEffect(() => {
        if (isTelegramApp && telegramTheme) {
            const isDark = telegramTheme === 'dark';
            setDarkMode(isDark);
            document.documentElement.classList.toggle('dark', isDark);
        }
    }, [telegramTheme, isTelegramApp]);

    return {
        darkMode,
        handleThemeChange,
        isTelegramControlled: isTelegramApp || isMobile
    };
}; 